/* stylelint-disable property-no-unknown */
:export {
  WHITE: #fff;
  OFF_WHITE: #f6f6f8;
  PURPLE: #645faa;
  BOLD_PURPLE: #6138f5;
  GREY: #666;
  GRAY: #666;
  DARK_GREY: #252525;
  DARK_GRAY: #252525;
  ALTERNATE_GREY: #dbdde4;
  ALTERNATE_GRAY: #dbdde4;
  LIGHT_GREY: #ccc;
  LIGHT_GRAY: #ccc;
  VERY_LIGHT_GREY: #e9e9e9;
  VERY_LIGHT_GRAY: #e9e9e9;
  GREEN: #0db14b;
  BLACK: #000;
  INDICATOR_BLUE: #1f69ff;
  BLUE: #0089cf;
  RED: #f00;
  YELLOW: #fdb913;
  ORANGE: #f37021;
  ROSE: #b42846;
  COMCAST_GREEN: #E2F0D9;
}

:root {
  --color-white: #fff;
  --color-off-white: #f6f6f8;
  --color-purple: #645faa;
  --color-bold-purple: #6138f5;
  --color-grey: #666;
  --color-gray: #666;
  --color-dark-grey: #252525;
  --color-dark-gray: #252525;
  --color-alternate-grey: #dbdde4;
  --color-alternate-gray: #dbdde4;
  --color-light-grey: #ccc;
  --color-light-gray: #ccc;
  --color-very-light-grey: #e9e9e9;
  --color-very-light-gray: #e9e9e9;
  --color-green: #0db14b;
  --color-black: #000;
  --color-indicator-blue: #1f69ff;
  --color-blue: #0089cf;
  --color-red: #f00;
  --color-yellow: #fdb913;
  --color-orange: #f37021;
  --color-rose: #b42846;
  --color-comcast-green: #E2F0D9;
  --color-comcast-yellow: #FFF2CC;
  --color-comcast-red: #FFD9D9;
  --color-light-orange: #FFF2CC;
  --color-light-green: #E2F0D9;
  --color-light-purple: #eae7fd;
  --color-dark-orange: #b84d0a;
  --color-dark-green: #007a00;
}

/* stylelint-disable property-no-unknown */
:export {
  sm: 766px;
  md: 1148px;
}

.level-display-container {
  display: flex;
  gap: 20px;
  right: 0;
  border-radius: 15px;
  color: #252525;
  position: relative;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  --color-half-circle-progress: #0089cf;
}
.level-display-container .title-container {
  position: absolute;
  top: 0;
  left: 0;
  font-size: 18px;
  line-height: 28px;
}
.level-display-container .level-container {
  display: flex;
  flex-direction: column;
  gap: 3px;
  flex: 1;
}
.level-display-container .level-container .level-display {
  font-size: 33px;
  line-height: 60px;
  font-weight: bold;
  color: #0089cf;
  margin-left: -0.1em;
}
@media screen and (max-width: 766px) {
  .level-display-container .level-container .level-display {
    font-size: 30px;
  }
}
.level-display-container .level-container .next-display {
  font-size: 14px;
  line-height: 20px;
}
.level-display-container .level-bar-container {
  display: flex;
  flex: 1;
  position: relative;
  align-items: center;
  justify-content: center;
}
.level-display-container .level-bar-container svg {
  width: 200px;
}
@media screen and (min-width: 766px) and (max-width: 1148px) {
  .level-display-container .level-bar-container svg {
    width: 165px;
  }
}
@media screen and (max-width: 766px) {
  .level-display-container .level-bar-container svg {
    width: 150px;
  }
}
.level-display-container .level-bar-container .level-credit-info {
  position: absolute;
  left: 50%;
  bottom: 16px;
  transform: translateX(-50%);
  text-align: center;
  display: flex;
  flex-direction: column;
}
.level-display-container .level-bar-container .level-credit-info .progress {
  font-size: 22px;
  line-height: 26px;
  font-weight: bold;
}
.level-display-container .level-bar-container .level-credit-info .text {
  font-size: 14px;
  line-height: 20px;
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */